// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__1E8B5","detailsBorder":"styles_detailsBorder__2IvUU"};